<i18n
  src="@/locales/views/agro_exporter/quality_control/container/list_containers.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="ae_quality_control_container_list_processes_path"
    :params="{
      agro_exporter_id: agro_exporter_id
    }"
  ></go-back-link>

  <bread-crumbs
    :labels="[module_name, agro_exporter_process?.name]"
  ></bread-crumbs>

  <template v-if="load_data_general">
    <h1 class="page-title">
      <i class="fa-solid fa-container-storage"></i
      ><span class="space-icon"></span>
      {{ $t("labels.title") }}
    </h1>

    <div class="mt-8 flex flex-col md:flex-row justify-between items-center">
      <div class="panel-plain-label">
        <badge-default
          :label="total_rows + ' ' + $t('labels.total_number_containers')"
        />
        <span class="space-actions" />
        <badge-default
          :label="total_inspections + ' ' + $t('labels.total_number_inspections')"
        />
      </div>
      <div class="flex flex-col-reverse md:flex-row-reverse gap-2">
        <white-button v-if="filtered" label="Limpiar" @click.prevent="clearFilters" />
        <white-button
          label="Filtrar"
          @click.prevent="filterContainers"
        />

        <input
          v-for="container_attribute in (agro_exporter_process?.container_attributes|| [])"
          :key="container_attribute.id"
          type="text"
          v-model.trim="filters.container_attributes[container_attribute.id]"
          :placeholder="container_attribute.name"
          class="shadow-sm focus:ring-lime-500 focus:border-lime-500 block sm:text-sm border-gray-300 rounded-md"
        />
        <input
          type="text"
          v-model.trim="filters.container_code"
          :placeholder="$t('model.container.container_code')"
          class="shadow-sm focus:ring-lime-500 focus:border-lime-500 block sm:text-sm border-gray-300 rounded-md"
        />
        <input
          type="text"
          v-model.trim="filters.week"
          :placeholder="$t('model.container.week')"
          class="shadow-sm focus:ring-lime-500 focus:border-lime-500 block sm:text-sm border-gray-300 rounded-md"
        />
      </div>
    </div>


    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.week") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.container_code") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.customer") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.load_date") }}
                  </th>
                  <th v-if="display_packing_house" scope="col" class="table-header-cell">
                    {{ $t("model.container.packing_house") }}
                  </th>
                  <th
                    v-for="container_attribute in agro_exporter_process.container_attributes"
                    :key="container_attribute.id"
                    scope="col"
                    class="table-header-cell"
                  >
                    {{ container_attribute.name }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.total_inspections") }}
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="container in containers"
                  :key="container.id"
                >
                  <td class="table-cell">
                    {{ container.week }}
                  </td>
                  <td class="table-cell-main">
                    {{ container.container_code }}
                  </td>
                  <td class="table-cell">
                    {{ container.customer?.name }}
                  </td>
                  <td class="table-cell">
                    {{ dateFormatter(container.load_date) }}
                  </td>
                  <td v-if="display_packing_house" class="table-cell">
                    {{ container.packing_house_names.join(", ") }}
                  </td>
                  <td
                    v-for="container_attribute in agro_exporter_process.container_attributes"
                    :key="container_attribute.id"
                    class="table-cell"
                  >
                    {{
                      containerAttributeValue(container, container_attribute)
                    }}
                  </td>
                  <td class="table-cell">
                    {{ container.total_inspections || "" }}
                  </td>
                  <td class="table-cell-action">
                    <button class="link" @click="goToListTemplates(container)">
                      <i class="fa-solid fa-pen"></i
                      ><span class="space-icon"></span>
                      {{ $t("labels.manage_link") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <table-paginator
      v-if="total_rows > rows_per_page"
      v-model="current_page"
      :total_rows="total_rows"
      :rows_per_page="rows_per_page"
    />
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/quality_control/container/list_containers.js";
import TablePaginator from "@/components/views/layout/TablePaginator.vue";

export default {
  name: "AEProductionContainerQualityListContainers",
  components: { TablePaginator },
  props: ["agro_exporter_id", "agro_exporter_process_id"],
  data() {
    return {
      load_data_general: false,
      agro_exporter_process: {},
      containers: [],
      total_rows: 0,
      total_inspections: 0,
      current_page: 1,
      rows_per_page: 15,
      exporter_process_quality_templates: [],
      filtering: false,
      filtered: false,
      filters: {
        container_code: "",
        week: "",
        container_attributes: {}
      },
    };
  },
  computed: {
    can_filter() {
      return Object.values(this.filters).some(f => f !== "");
    },
    display_packing_house: function() {
      let packing_houses = new Set()
      this.containers.forEach(container => {
        container.packing_house_names.forEach(packing_house => {
          packing_houses.add(packing_house)
        })
      })
      return packing_houses.size > 1;
    }
  },
  methods: {
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchContainers: async function () {
      let { data } = await Requester.fetchContainers(
        this.agro_exporter_process_id,
        {
          ...this.filters,
          current_page: this.current_page,
          rows_per_page: this.rows_per_page
        }
      );
      this.containers = data.records;
      this.total_rows = data.total;
      this.total_inspections = data.total_inspections;
      this.load_data_general = true;
    },
    fetchExporterQualityTemplates: async function () {
      let response = await Requester.fetchExporterQualityTemplates(
        this.agro_exporter_process_id
      );
      this.exporter_process_quality_templates = response.data;
    },
    filterContainers: async function () {
      if (!this.filtering && this.can_filter) {
        this.filtering = true;
        this.current_page = 1;
        try {
          await this.fetchContainers();
          this.filtered = true;
        } catch (error) {
          console.error("Error filtering containers:", error);
        } finally {
          this.filtering = false;
        }
      }
    },

    containerAttributeValue: function (container, container_attribute) {
      return container.container_attribute_values.find(
        (value) =>
          value.exporter_process_container_attribute_id ===
          container_attribute.id
      )?.value
    },

    clearFilters: function () {
      this.filtering = false;
      this.filtered = false;
      this.filters = {
        container_code: "",
        week: "",
        container_attributes: {}
      };
      this.current_page = 1;
      this.fetchContainers();
    },
    goToListTemplates: function (container) {
      this.$router.push({
        name: "ae_quality_control_container_list_templates_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: container.id
        }
      });
    },
    goToTemplateGraph: function (exporter_process_quality_template) {
      this.$router.push({
        name: "ae_quality_control_container_containers_inspect_graphs_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          exporter_process_quality_template_id:
            exporter_process_quality_template.id
        }
      });
    }
  },
  watch:{
    rows_per_page: function () {
      this.fetchContainers();
    },
    current_page: function () {
      this.fetchContainers();
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => {
        this.fetchAgroExporterProcess();
        this.fetchContainers();
        this.fetchExporterQualityTemplates();
      })
    );
  }
};
</script>
